// assets
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LocalGroceryStoreOutlinedIcon from '@mui/icons-material/LocalGroceryStoreOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import { VerifiedUserOutlined } from '@mui/icons-material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

// icons
const icons = {
  dashboard: DashboardOutlinedIcon,
  products: ViewInArOutlinedIcon,
  product_listing: LayersOutlinedIcon,
  sales_channels: StorefrontOutlinedIcon,
  fullfillment_partners: AirportShuttleOutlinedIcon,
  orders: LocalGroceryStoreOutlinedIcon,
  pricing_rules: AttachMoneyOutlinedIcon,
  inventory_sync: AutorenewOutlinedIcon,
  competitors: TrendingUpOutlinedIcon,
  integrations: LinkOutlinedIcon,
  audit_logs: SummarizeOutlinedIcon,
  settings: SettingsOutlinedIcon,
  user_roles: VerifiedUserOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      permission: ['dashboard.view'],
      url: '/',
      icon: icons.dashboard,
      breadcrumbs: false
    },
    {
      id: 'products',
      title: 'Catalog',
      type: 'collapse',
      permission: ['products.view', 'products.create', 'products.update', 'products.delete', 'listings.view', 'listings.update', 'listings.delete', 'inventory.view'],

      icon: icons.products,
      children: [
        {
          id: 'products-view',
          title: 'Inventory',
          type: 'item',
          permission: ['inventory.view'],
          url: '/catalog/inventory',
          breadcrumbs: false
        },
        {
          id: 'product-catalog',
          title: 'Product Catalog',
          type: 'item',
          permission: ['products.view', 'products.create', 'products.update', 'products.delete'],
          url: '/product-catalog',
          breadcrumbs: false
        },
        {
          id: 'channel-listing',
          title: 'Channel Listing',
          type: 'item',
          permission: ['listings.view', 'listings.update', 'listings.delete'],
          url: '/listing',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'integration',
      title: 'Integrations',
      type: 'collapse',
      permission: ['channels.view', 'channels.create', 'fulfillment.view'],

      icon: icons.integrations,
      children: [
        {
          id: 'integration-view',
          title: 'Sales Channels',
          type: 'item',
          permission: ['channels.view', 'channels.create'],
          url: '/integration/sales-channels',
          breadcrumbs: false
        },
        {
          id: 'integration-add',
          title: 'Fullfillment Partners',
          type: 'item',
          permission: ['fulfillment.view'],
          url: '/integration/fullfillment-partners',
          breadcrumbs: false
        }
      ]
    },
    // {
    //   id: 'product_listing',
    //   title: 'Product Listings',
    //   type: 'item',
    //   url: '/product-listings',
    //   icon: icons.product_listing,
    //   target: true
    // },
    // {
    //   id: 'sales',
    //   title: 'Sales Channels',
    //   type: 'item',
    //   url: '/sales-channels',
    //   icon: icons.sales_channels,
    //   target: true
    // },
    // {
    //   id: 'fullfillment_partners',
    //   title: 'Fullfillment Partners',
    //   type: 'item',
    //   url: '/fullfillment-partners',
    //   icon: icons.fullfillment_partners,
    //   target: true
    // },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/orders',
      permission: ['orders.view', 'orders.update'],
      icon: icons.orders,
      target: true
    },
    // {
    //   id: 'pricing',
    //   title: 'Pricing Rules',
    //   type: 'item',
    //   url: '/pricing-rules',
    //   icon: icons.pricing_rules,
    //   target: true
    // },
    // {
    //   id: 'inventory',
    //   title: 'Inventory Sync',
    //   type: 'item',
    //   url: '/inventory-sync',
    //   icon: icons.inventory_sync,
    //   target: true
    // },
    {
      id: 'competitor',
      title: 'Competitors',
      type: 'item',
      url: '/competitors',
            permission: ['competitors.view'],

      icon: icons.competitors,
      target: true
    },

    {
      id: 'audit',
      title: 'Audit Logs',
      type: 'item',
      permission: ['auditlogs.view'],
      url: '/audit-logs',
      icon: icons.audit_logs,
      target: true
    },
    {
      id: 'user',
      title: 'User & Roles',
      type: 'item',
      permission: ['users.view', 'users.create', 'users.update', 'users.delete', 'roles.view', 'roles.create', 'roles.update', 'roles.delete'],
      url: '/users-management',
      icon: icons.user_roles,
      target: true
    },
    {
      id: 'settings',
      title: 'Settings',
      permission: ['settings.view', 'settings.update'],
      type: 'item',
      url: '/settings',
      icon: icons.settings,
      target: true
    }
  ]
};

export default dashboard;
